import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import MediaUpload from '../../../components/MediaUpload';
import BannersPreview from '../banner/BannersPreview';
import { useAppDispatch, useAppSelector } from '../../../store/redux-hooks';
import {
  gallerySelector,
  getGalleryAllList,
} from '../../../features/gallerySlice';
import { API_STATUS } from '../../../utils/Constant';
import CenterSpinner from '../../../components/CenterSpinner';
import AlertPopUP from '../../modals/AlertPopUp';
import {
  alertPopupToggle,
  onRemoveClick,
  uploadSelectedFiles,
} from './galleryPageHelper';

const GalleryPage: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const [newFiles, setNewFiles] = useState<File[]>([]);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const apiStatus = useAppSelector(gallerySelector)?.apiProgressStatus;
  const galleryList = useAppSelector(gallerySelector)?.allList;
  const [deleteId, setDeleteId] = useState<string | number>('');
  const [showAlertPopUp, setShowAlertPopUp] = useState<boolean>(false);

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  useEffect(() => {
    dispatch(getGalleryAllList());
  }, []);

  return (
    <div className="ml-4">
      <Label className="text-heading">Gallery</Label>
      <div className="task-item-parent-view bg-white">
        <div className="me-1">
          <MediaUpload
            selectedFiles={newFiles}
            setSelectedFiles={setNewFiles}
            supportedFiles={['.png', '.jpg']}
            maxFiles={5}
            uploadFiles={(files: any[]) => {
              uploadSelectedFiles(files, galleryList, dispatch, {
                setShowLoader,
                setNewFiles,
              });
            }}
            maxFileSizeInBytes={1024 * 1024}
          />
          <BannersPreview
            banners={galleryList}
            handleRemove={(id: string | number) => {
              onRemoveClick(id, setShowAlertPopUp, setDeleteId);
            }}
            keyId="id"
            keyUrlName="galleryUrl"
            showPreviewImage={true}
          />
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
      {showAlertPopUp && (
        <AlertPopUP
          isOpen={showAlertPopUp}
          toggle={(action: string) => {
            alertPopupToggle(action, dispatch, {
              setShowLoader,
              setShowAlertPopUp,
              setDeleteId,
              deleteId,
            });
          }}
        />
      )}
    </div>
  );
};

export default GalleryPage;
